import { USER_ID } from '../keys/keys';
import { ItemUPC } from './itemUPC.model';


export class Item {
  itemManagerId!: number;
  itemHeirarchyDataId!: number;
  documentId!: any;
  documentPath!: string;
  itemManagerUPC!: ItemUPC[];
  itemModelNumber!: number;
  brandId!: any;
  productLineId!: any;
  productGroupId!: any;
  productFamilyId!: any;
  parentProductId!: any;
  description!: string;
  productStatus!: string;
  productCategory!: string;
  sku!: string;
  msrp!: number;
  cost!: number;
  color!: any;
  capacity!: any;
  screenSize!: number;
  palletQuantity!: number;
  casePackQuantity!: number;
  leadTimeI!: number;
  createdById!: number;
  createdByName!: string;
  createdDate!: Date;
  modifiedById!: number;
  modifiedByName!: string;
  modifiedDate!: Date;
  active!: boolean;
  searchText!: string;
  currentUserId!: number;
  accType!: String;
  editPermission!: any;
  streetDate: any;
  [key: string]: any;
  constructor(item?: Item) {
    if (item) {
      this.itemManagerId = item.itemManagerId || 0;
      this.documentId = item.documentId || null;
      this.documentPath = item.documentPath || '';
      this.itemHeirarchyDataId = item.itemHeirarchyDataId || 0;
      this.itemManagerUPC = item.itemManagerUPC || new Array(new ItemUPC());
      this.itemModelNumber = item.itemModelNumber || 0;
      this.brandId = item.brandId || null;
      this.productGroupId = item.productGroupId || null;
      this.productFamilyId = item.productFamilyId || null;
      this.parentProductId = item.parentProductId || null;
      this.productLineId = item.productLineId || null;
      this.description = item.description || '';
      this.msrp = item.msrp || 0;
      this.cost = item.cost || 0;
      this.color = item.color || null;
      this.capacity = item.capacity || null;
      this.screenSize = item.screenSize || 0;
      this.palletQuantity = item.palletQuantity || 0;
      this.casePackQuantity = item.casePackQuantity || 0;
      this.leadTimeI = item.leadTimeI || 0;
      this.currentUserId = JSON.parse(localStorage.getItem(USER_ID)!);
      this.productStatus = '';
      this.productCategory = '';
      this.sku = '';
      this.accType = '';
      this.active = true;
    }
  }
}



